import type { ReactNode } from "react";
import { Divider } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import { useDevice } from "../../useDevice";
import Box from "../Box";
import CustomKeyboardAvoidingView from "../CustomKeyboardAvoidingView";
import ScrollContainer from "../ScrollContainer";

const Left = ({
	children,
	showDivider = true,
}: {
	children: ReactNode;
	showDivider?: boolean;
}) => {
	const theme = useAppTheme();
	return (
		<Box flex={1} minHeight={0}>
			<Box
				flex={1}
				minHeight={0}
				backgroundColor={theme.colors.surface}
				borderRadius={theme.roundness * 2}
			>
				{children}
			</Box>
			{showDivider && (
				<Box
					style={{ width: 1, backgroundColor: theme.colors.outlineVariant }}
				/>
			)}
		</Box>
	);
};

const LeftHeader = ({ children }: { children: ReactNode }) => {
	return (
		<Box>
			<Box padding={16} gap={8}>
				{children}
			</Box>
			<Divider />
		</Box>
	);
};

const LeftContent = ({ children }: { children: ReactNode }) => (
	<ScrollContainer
		stableScrollbarGutter
		style={{ flex: 1, minHeight: 0 }}
		contentContainerStyle={{
			paddingHorizontal: 16,
			paddingTop: 16,
			paddingBottom: 44,
		}}
	>
		{children}
	</ScrollContainer>
);

const Right = ({ children }: { children: ReactNode }) => {
	const { isMediumWindowSize } = useDevice();
	return (
		<Box flex={1}>
			<CustomKeyboardAvoidingView
				showsVerticalScrollIndicator={false}
				style={{ flex: 1 }}
				contentContainerStyle={{
					flexGrow: 1,
					paddingRight: isMediumWindowSize ? 16 : 0,
					paddingBottom: 200,
				}}
			>
				<Box flex={1} paddingTop={24} gap={16}>
					{children}
				</Box>
			</CustomKeyboardAvoidingView>
		</Box>
	);
};

const SplitLayout = ({ children }: { children: ReactNode }) => {
	return (
		<Box flex={1} flexDirection="row" gap={24}>
			{children}
		</Box>
	);
};

SplitLayout.Left = Left;
SplitLayout.LeftHeader = LeftHeader;
SplitLayout.LeftContent = LeftContent;
SplitLayout.Right = Right;

export default SplitLayout;
